/**
 *
 * @author Aleynikov Boris <alynikov.boris@gmail.com>.
 */

'use strict';

var app = require('mag-app'),
    tools = {},
    $parserAElement = document.createElement('a'),
    resolutionMap = {
        /* eslint-disable-next-line*/
        '480': {width: 720, height: 480},
        '480i': {width: 720, height: 480},
        '480p': {width: 720, height: 480},

        /* eslint-disable-next-line*/
        '576': {width: 720, height: 576},
        '576i': {width: 720, height: 576},
        '576p': {width: 720, height: 576},

        /* eslint-disable-next-line*/
        '720': {width: 1280, height: 720},
        '720p': {width: 1280, height: 720},
        '720p60': {width: 1280, height: 720},

        /* eslint-disable-next-line*/
        '1080': {width: 1920, height: 1080},
        '1080i': {width: 1920, height: 1080},
        '1080i60': {width: 1920, height: 1080},
        '1080p': {width: 1920, height: 1080},
        '1080p60': {width: 1920, height: 1080},

        '3840x2160p30': {width: 3840, height: 2160},
        '3840x2160p25': {width: 3840, height: 2160},
        '3840x2160p50': {width: 3840, height: 2160},
        '3840x2160p60': {width: 3840, height: 2160}
    };

/*eslint id-length:0 no-mixed-operators:0*/

tools.parseTime = function  ( secToParse ) {
    var hour, min, sec;

    if ( secToParse >= 0 ) {
        hour = Math.floor(secToParse / 3600);
        min = Math.floor((secToParse - hour * 3600) / 60);
        sec = secToParse - hour * 3600 - min * 60;
        if ( hour < 10 ) {
            hour = '0' + hour;
        }
        if ( sec < 10 ) {
            sec = '0' + sec;
        }
        if ( min < 10 ) {
            min = '0' + min;
        }
    } else {
        secToParse = Math.abs(secToParse);
        hour = Math.floor(secToParse / 3600);
        min = Math.floor((secToParse - hour * 3600) / 60);
        sec = secToParse - hour * 3600 - min * 60;
        if ( hour < 10 ) {
            hour = '0' + hour;
        }
        if ( sec < 10 ) {
            sec = '0' + sec;
        }
        if ( min < 10 ) {
            min = '0' + min;
        }
        hour = '-' + hour;
    }

    return {hour: hour, min: min, sec: sec};
};


tools.checkUsb = function () {
    /*eslint-disable*/
    var usbs = JSON.parse(top.gSTB.GetStorageInfo('{}')).result || [],
        index;

    for ( index = 0; index < usbs.length; index++ ) {
        if ( usbs[index].mountPath && usbs[index].isReadOnly === 0 ) {
            return true;
        }
    }

    return false;
    /*eslint-enable*/
};


tools.getCodecImageName = function ( codecType ) {
    var url = './img/',
        height = app.metrics.height === 480 ? 576 : app.metrics.height,
        codecs = {
            1: 'mpeg2.png',
            2: 'mp3.png',
            3: 'dolby.png',
            4: 'dolby.png',
            5: 'pcm.png',
            6: 'ogg.png',
            7: 'dts.png',
            8: 'dolby.png'
        };

    if ( codecType && codecs[codecType] ) {
        url += height + '/codec/' + codecs[codecType];
    } else {
        url = '';
    }

    return url;
};


tools.getRealViewPort = function ( vp ) {
    var currentResolutionName = top.gSTB.RDir('vmode'), // eslint-disable-line
        currentResolution = resolutionMap[currentResolutionName]
            || resolutionMap[currentResolutionName.match(/^(\d)*/g)[0]],
        currentGraphic = {
            height: screen.height,
            width: screen.width
        },
        result = {};

    result.x = Math.round(vp.x * currentResolution.width / currentGraphic.width);
    result.width = Math.round(vp.width * currentResolution.width / currentGraphic.width);
    result.y = Math.round(vp.y * currentResolution.height / currentGraphic.height);
    result.height = Math.round(vp.height * currentResolution.height / currentGraphic.height);

    console.log(result, 'set processed viewport');

    return result;
};


tools.parseUriString = function ( uriString ) {
    $parserAElement.href = uriString;

    return {
        protocol: $parserAElement.protocol,
        port: $parserAElement.port,
        host: $parserAElement.hostname
    };
};


tools.useSingleModeByDeviceModel = function () {
    var excludeList = require('../config').preventMultiplePlayer || [];

    if ( !core.device ) {
        return false;
    }

    return excludeList.indexOf(core.device.model) > -1;
};


tools.detectPipSupport = function () {
    var excludeList = app.config.pipDisableModels;

    // We should disable pip if ministra use leanback launcher. it will be repaired in future. #fix 20140, #23941
    if ( core.packageMap && core.packageMap[require('../../../../launcher-prime/package').name] ) {
        return false;
    }

    if ( !core.device ) {
        return true;
    }

    return excludeList.indexOf(core.device.model) === -1;
};


tools.removePipOnAudioMime = function ( intent ) {
    if ( intent.mime === 'content/audio' && core.device && core.device.name === 'MAG256' ) {
        if ( intent.data.controls ) {
            intent.data.controls.pip = false;
        } else {
            intent.data.controls = {pip: false};
        }

        return true;
    }

    return false;
};


tools.checkAppByPid = function ( applicationPid ) {
    // we need to copy top.core.taskManager.stack array because we use Array.findIndex polyfill and top frame may not have it
    var stackCopy = [].concat(top.core.taskManager.stack);

    return stackCopy.findIndex(function ( application ) {
        return application.config.pid === applicationPid;
    }) > -1;
};

module.exports = tools;
